import styled from 'styled-components';
import { FileTypesAccept } from 'pages/OpenProtocol/interface';

export const FilesInput = styled.input.attrs({  
  id: "openProtocolFilesSimple",
  stateName: "openProtocolFilesSimple",
  placeholder: "Arquivos",
  name: "Arquivos",
  className: "d-none",
  type: "file",
  multiple: true,  
  accept: FileTypesAccept.toString()
})``;
